import { Radio as DSRadio } from "@packages/ds";

import { TrackedRadioInput } from "./TrackedRadio";

export type { TrackedRadioInputProps } from "./TrackedRadio";

// Export the tracked input directly
export { TrackedRadioInput as Input };

// Re-export the namespaced components from design system
export const Group = DSRadio.Group;
export const Label = DSRadio.Label;
export const Wrapper = DSRadio.Wrapper;
export const Item = DSRadio.Item;
export const Indicator = DSRadio.Indicator;
export const OptionDetails = DSRadio.OptionDetails;

// Provide a Radio namespace for consistent pattern
export const Radio = {
  Input: TrackedRadioInput,
  Group: DSRadio.Group,
  Label: DSRadio.Label,
  Wrapper: DSRadio.Wrapper,
  Item: DSRadio.Item,
  Indicator: DSRadio.Indicator,
  OptionDetails: DSRadio.OptionDetails
};
